export type ApiResponse<T> = {
  isError?: boolean;
  message?: string;
  responseException?: string;
  result?: T | null;
  statusCode: number;
  version?: string;
}

export type QueryWrapper = {
  jobId: string;
  clientId: string;
  queries: Query[]
}

export type Query = {
  type: number,
  value: string,
  status?: QueryStatus
}

export enum QueryStatus {
  QUEUE = 0,
  PROCESSING,
  UPLOADING,
  DONE,
  ERROR
}
export type Token = {
  id_token: string;
}

export type Params = {
  code?: string;
}

export type JWTToken = {
  family_name: string;
  given_name: string;
  preferredMail: string;
  sub: string;
  uid: string;
  country: string;
  exp: number;
}

export enum TokenStatus {
  OK = 0,
  EXPIRED = 1,
  NO_TOKEN = 2
}

export type Snack = {
  key?: string,
  message: string;
  options: {
    variant: "default" | "success" | "error" | "warning" | "info";
    persist?: boolean;
  }
}